import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import consiliumLogo from '../assets/images/Consilium-small.png';

interface HeaderProps {
  /** Href for the top-right "Download" CTA. Each page has its own in-page
   * download/CTA section id to scroll to (or "#download" on the homepage
   * and FAQ page) — pass that page's id here. */
  downloadHref?: string;
}

const Header: React.FC<HeaderProps> = ({ downloadHref = '#download' }) => {
  const [safetyDataOpen, setSafetyDataOpen] = useState(false);
  const dropdownRef = useRef<HTMLLIElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setSafetyDataOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <nav className="navbar">
      <div className="logo">
        <Link to="/" aria-label="Consilium home">
          <img src={consiliumLogo} alt="Consilium" className="logo-image logo-image-consilium" />
        </Link>
      </div>
      <ul className="nav-links">
        <li><Link to="/">Home</Link></li>
        <li><Link to="/features">Features</Link></li>
        <li><Link to="/breaking-news-problem">Breaking News Problem</Link></li>
        <li className="nav-dropdown" ref={dropdownRef}>
          <button
            type="button"
            className="nav-dropdown-trigger"
            aria-haspopup="true"
            aria-expanded={safetyDataOpen}
            onClick={() => setSafetyDataOpen((open) => !open)}
          >
            Safety Data <span className="nav-dropdown-caret" aria-hidden="true">▾</span>
          </button>
          <ul className={`nav-dropdown-menu${safetyDataOpen ? ' open' : ''}`}>
            <li>
              <Link to="/public-safety-data" onClick={() => setSafetyDataOpen(false)}>
                Safety Data Guide
              </Link>
            </li>
            <li>
              <a href="/hazards/earthquakes/" onClick={() => setSafetyDataOpen(false)}>
                Weekly Earthquake Report
              </a>
            </li>
            <li>
              <a href="/hazards/chemical-incidents/" onClick={() => setSafetyDataOpen(false)}>
                Weekly Chemical Incidents Report
              </a>
            </li>
            <li>
              <a href="/crime/" onClick={() => setSafetyDataOpen(false)}>
                Weekly US Crime Report
              </a>
            </li>
          </ul>
        </li>
        <li><Link to="/health-environmental-data">Health &amp; Environment</Link></li>
        <li><a href="/privacy.html">Privacy Policy</a></li>
        <li><a href="/account-deletion.html">Account Deletion</a></li>
        <li><Link to="/faq">FAQ</Link></li>
        <li><a href={downloadHref} className="nav-cta">Download</a></li>
      </ul>
    </nav>
  );
};

export default Header;
